import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AppButton, AppTextField } from "../../../components/form";
import { AppSlideOver } from "../../../components/layout";

type Props = {
  open: boolean;
  analysisText: string;
  onChange: (value: string) => void;
  onClose: () => void;
  onSave: () => void;
  saving?: boolean;
};

export default function PrepAnalysisPanel({
  open,
  analysisText,
  onChange,
  onClose,
  onSave,
  saving,
}: Props) {
  const { t } = useTranslation();

  return (
    <AppSlideOver
      open={open}
      onClose={onClose}
      size="lg"
      title={t("prep.design.analysisPanelTitle")}
      actions={
        <>
          <AppButton variant="outlined" onClick={onClose}>
            {t("common.cancel")}
          </AppButton>
          <AppButton variant="contained" onClick={onSave} disabled={saving || !analysisText.trim()}>
            {t("prep.design.saveAnalysis")}
          </AppButton>
        </>
      }
    >
      <Stack spacing={2}>
        <Typography variant="body2" color="text.secondary">
          {t("prep.design.analysisPanelHint")}
        </Typography>
        <AppTextField
          label={t("prep.design.analysis")}
          value={analysisText}
          onChange={(e) => onChange(e.target.value)}
          multiline
          minRows={16}
          fullWidth
        />
      </Stack>
    </AppSlideOver>
  );
}
